// @ts-strict-ignore
import { getJson, postJson } from 'utils/http';

import { Notification } from './Notification';

export const fetchNotifications = (): Promise<Array<Notification>> =>
  getJson('/data/notifications').then(({ notifications }) => notifications);

export const dismissNotifications = (notificationIds: Array<string>) =>
  postJson('/data/notifications-read', {
    notificationIds,
  }).then(({ notifications }) => notifications);
